import { useSchemaOrg } from '@unhead/schema-org/react';

/**
 * @type {import('$types/components/partials/offices').OfficeSchema}
 */

const OfficeSchema = ({ page, url }) => {
    const homeUrl = url?.split('/').slice(0, 3).join('/');

    /** @type {Record<string, any>} */
    const schema = {
        '@type': 'RealEstateAgent',
        '@id': url,
        name: page?.seoTitle || page?.title,
        url: homeUrl,
    };

    if (page?.address) {
        const plainAddress = page.address.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        schema.address = {
            '@type': 'PostalAddress',
            name: plainAddress,
        };
    }

    if (page?.coordinates?.lat && page?.coordinates?.lng) {
        schema.geo = {
            '@type': 'GeoCoordinates',
            latitude: page.coordinates.lat,
            longitude: page.coordinates.lng,
        };

        schema.hasMap = `https://www.google.com/maps?q=${page.coordinates.lat},${page.coordinates.lng}`;
    }

    if (page?.primaryPhoneNumber?.phone) {
        schema.telephone = page.primaryPhoneNumber.phone;
    }

    if (page?.openingHours) {
        schema.openingHours = page.openingHours;
    }

    if (page?.officeEmail?.email) {
        schema.email = page.officeEmail.email;
    }

    if (page?.coverImage?.src) {
        schema.image = {
            '@type': 'ImageObject',
            url: page.coverImage.src,
        };
    }

    useSchemaOrg(page ? [schema] : [], { tagPosition: 'head' });

    return null;
};

export default OfficeSchema;
